import Footer from "components/Footers/Footer.js";
// Just so we don't have the same exact thing in both of the footer files
export default Footer;
